export default {
  fallbackLocale: 'es-MX',
  locale: 'es-MX',
  messages: {
    'es-MX': {
        home: 'Inicio',
        vehicles: 'Autos',
        support: 'Soporte (AMS)',
        settings: 'Configuraciones',
        faqs: 'Preguntas frecuentes',
        customsDeclaration: 'Pedimentos',
        logoff: 'Cerrar sesión',
        locale: 'Inglés',
        localeCaption: 'Cambiar idioma a',
        searchCaption: 'Buscar'
    },
    en: {
        home: 'Home',
        vehicles: 'Vehicles',
        support: 'Support (AMS)',
        settings: 'Settings',
        customsDeclaration: 'Customs declaration',
        faqs: 'FAQ\'s',
        logoff: 'Logoff',
        locale: 'Spanish',
        localeCaption: 'Set language to',
        searchCaption: 'Search'
    }
  }
}
